import { Directive, EventEmitter, Inject, Input, Optional, Output, SkipSelf, WritableSignal, inject, signal } from "@angular/core";
import { LANGUAGE, Language, MemberQuery, MemberService } from "@fgb/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap/dropdown/dropdown";


/**
 * @TODO - languages are subject to change, as it will be fetched from the server
 * - inject the LANGUAGE with the data from the api
 */
@Directive()
export class LanguageSelectorBase{
  private memberQuery = inject(MemberQuery);
  protected memberService: MemberService = inject(MemberService);
  currentLanguage: WritableSignal<Language | undefined> = signal(this.getCurrentLanguageByLcid(this.memberQuery.getUserContext()?.lcid));
  @Output() dataChange: EventEmitter<Language> = new EventEmitter();
  @Input() visibleLanguagesByLcid: string[] = [];

  constructor(@Optional() @SkipSelf() @Inject(LANGUAGE) public languages: Language[] = []){
  }  
  
  useLanguage(language: Language | undefined) {
    if(language){
      this.memberService.setLcid(+language.lcid).then(() => {
        this.dataChange.emit(language);
        location.reload();
      });
    }
  }

  getCurrentLanguageByLcid(lcid: string | undefined): Language | undefined{
     return this.languages.find(t => t.lcid === lcid);
  }
  
  closeDropDown(dropdown: NgbDropdown) {
    dropdown.close();
  }

  get filteredLanguages(){
    if (!this.visibleLanguagesByLcid?.length) {
      return this.languages;
    }
    return this.languages.filter(lang => this.visibleLanguagesByLcid.includes(lang.lcid));
  }
}